module.exports = "images/france-2.332ac346.png";